import { Link } from 'react-router-dom';
import { motion } from 'motion/react';

const APP = import.meta.env.VITE_APP_NAME ?? 'ProtoLive Studio';

export default function PrivacyPage() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      style={{ height: '100dvh', overflowY: 'auto', WebkitOverflowScrolling: 'touch', backgroundColor: 'var(--bg)' }}
    >
      <article style={{ maxWidth: 720, margin: '0 auto', padding: '24px 18px', fontSize: 15, lineHeight: 1.55 }}>
        <p><Link to="/">← back</Link></p>
        <h1 style={{ fontSize: 18, marginBottom: 6 }}>privacy policy</h1>
        <p style={{ color: 'var(--fg-dim)', marginBottom: 18 }}>Last updated: 2026-05-21</p>

        <p><strong>{APP}</strong> is a creator tool for image and video direction. This policy explains
        what we collect, what we don't, and how third-party AI providers
        handle the prompts and assets you choose to send them.</p>

        <h3>What we store on your device</h3>
        <ul>
          <li>Your API keys for Google, OpenAI, BytePlus, and xAI — encrypted in your browser's
          IndexedDB. They never leave your device except when you make a generation
          request, in which case they are forwarded to that provider via our
          stateless proxy.</li>
          <li>Your chat sessions, character/scene templates, and the images, videos, and audio
          you upload or generate. Stored locally; deleted when you clear browser data.</li>
        </ul>

        <h3>What we store in the cloud (only if you sign in)</h3>
        <p>If you choose to sign in with Google, your sessions, templates, and generated
        assets are mirrored to your private Supabase storage. Row-level security
        restricts every row to your user. You can delete your account and all data
        at any time from settings.</p>

        <h3>What we never store</h3>
        <ul>
          <li>Your API keys are never written to our servers, our logs, or any
          analytics system.</li>
          <li>We do not run advertising trackers or third-party analytics.</li>
        </ul>

        <h3>Third-party AI providers</h3>
        <p>When you send a prompt or asset to a model, the relevant provider receives
        your input under their own terms. Their handling of your data is governed by:</p>
        <ul>
          <li>Google AI (Gemini, Imagen, Veo): <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">policies.google.com/privacy</a></li>
          <li>OpenAI: <a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noreferrer">openai.com/policies/privacy-policy</a></li>
          <li>BytePlus ModelArk: <a href="https://www.byteplus.com/legal/privacy-policy" target="_blank" rel="noreferrer">byteplus.com/legal/privacy-policy</a></li>
          <li>xAI (Grok): <a href="https://x.ai/legal/privacy-policy" target="_blank" rel="noreferrer">x.ai/legal/privacy-policy</a></li>
        </ul>

        <h3>Children</h3>
        <p>{APP} is not directed to children under 13 and we do not knowingly collect
        data from them.</p>

        <h3>Your rights</h3>
        <p>You may delete all local data by clearing the site from your browser. If
        you signed in, you may request deletion of your cloud-stored data by
        contacting the operator of this deployment.</p>

        <h3>Contact</h3>
        <p>Questions about this policy can be sent to the email address provided by the
        operator of this deployment.</p>
      </article>
    </motion.div>
  );
}
